import { useEffect, useState } from "react";
import { userAuthorization } from "../../../api/api";

import { languageSetterList } from "../../Constants";

export default function AuthorizationForm({ language, onAuthorizationSuccess }) {
  const errorText = languageSetterList.authorizationError401[language];

  const [userName, setUserName] = useState(() => {
    return localStorage.getItem("lastUserName") || "";
  });
  const [password, setPassword] = useState("");

  const [isNameFocused, setNameFocused] = useState(false);
  const [isPassFocused, setPassFocused] = useState(false);

  const isNameActive = isNameFocused || userName.trim() !== "";
  const isPassActive = isPassFocused || password !== "";

  const [error, setError] = useState("");

  const [isLoading, setLoading] = useState(false);

  const isEnable = userName.trim() !== "" && password !== "";

  // Сохраняем последнее введённое имя пользователя
  useEffect(() => {
    if (userName.trim() !== "") {
      localStorage.setItem("lastUserName", userName);
    }
  }, [userName]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    setError("");
    setLoading(true);

    try {
      const data = await userAuthorization(userName, password);

      sessionStorage.setItem("token", data.access_token);

      onAuthorizationSuccess();
    } catch (error) {
      setError(errorText);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="authorization-form access-form flex-column" onSubmit={handleSubmit}>
      <h1 className="access-form__title authorization-form__title">{languageSetterList.authorizationTitle[language]}</h1>

      {/* ERROR */}

      {error && <p className="authorization-form__error access-form__error">{error}</p>}

      {/* USER NAME */}

      <label
        htmlFor="userName"
        className={`authorization-form__label access-form__label flex-column ${isNameActive ? "authorization-form__label--focused" : ""}`}
      >
        <span
          className={`access-form__placeholder authorization-form__placeholder ${
            isNameActive ? "authorization-form__placeholder--focused" : ""
          }`}
        >
          {languageSetterList.userName[language]}
        </span>

        <input
          id="userName"
          type="text"
          value={userName}
          onChange={(event) => {
            setUserName(event.target.value);
            setError("");
          }}
          onFocus={() => setNameFocused(true)}
          onBlur={() => setNameFocused(false)}
          className={`authorization-form__input ${isNameActive ? "authorization-form__input--focused" : ""}`}
        />
      </label>

      {/* PASSWORD */}

      <label
        htmlFor="password"
        className={`authorization-form__label access-form__label flex-column ${isPassActive ? "authorization-form__label--focused" : ""}`}
      >
        <span
          className={`access-form__placeholder authorization-form__placeholder ${
            isPassActive ? "authorization-form__placeholder--focused" : ""
          }`}
        >
          {languageSetterList.userPass[language]}
        </span>

        <input
          id="password"
          type="password"
          value={password}
          onChange={(event) => {
            setPassword(event.target.value);
            setError("");
          }}
          onFocus={() => setPassFocused(true)}
          onBlur={() => setPassFocused(false)}
          className={`authorization-form__input ${isPassActive ? "authorization-form__input--focused" : ""}`}
        />
      </label>

      {/* SUBMIT */}

      <button type="submit" className="authorization-form__button access-button button uppercase" disabled={!isEnable || isLoading}>
        {isLoading ? languageSetterList.process[language] : languageSetterList.authorizationButton[language]}
      </button>
    </form>
  );
}
